import {
  Map as MapboxMap,
  NavigationControl,
  ScaleControl,
  Popup,
} from 'mapbox-gl';
import {
  BOUNDS_SMALL,
  BOUNDS_LARGE,
  TILESET,
  STYLE,
  SOURCE,
  SOURCE_LAYER,
  TOKEN,
} from './maputils/constantsOctober2024';
import { geocoder } from './maputils/geocoder';
import { renderTooltip } from './maputils/tooltip';
import { json } from 'd3-fetch';
import { findSvelteComponentContainer } from './utils/render.js';

let w = window.innerWidth;
const bounds = w < 500 ? BOUNDS_SMALL : BOUNDS_LARGE;

/**
 *
 * @param {Element} container
 */

const dataURL = new URL('../_data/cities_trend.json', import.meta.url);

async function trendLookup(p) {
  const trendData = await json(dataURL);
  let city = p['City'];
  let match = trendData['features'].find(
    (item) => item.properties.City == city
  );
  return Object(match.properties.Months);
}

let t;

export async function renderShapesMap(container) {
  // create our popup but don't add to the map for now
  const popup = new Popup({
    closeButton: false,
    closeOnClick: false,
    offset: 8,
  });

  // create our map - options you can add https://docs.mapbox.com/mapbox-gl-js/api/map/
  const map = new MapboxMap({
    accessToken: TOKEN,
    container,
    style: STYLE,
    bounds: [
      -119.69058403564895, 33.68333042519106, -116.97570978225754,
      34.8185484073039,
    ],
    // minZoom: 7.5,
    maxBounds: [
      -121.0, 32.68333042519106, -113.97570978225754, 35.8185484073039,
    ],
    cooperativeGestures: true,
  });

  // disable map rotation using right click + drag
  map.dragRotate.disable();
  // disable map rotation using touch rotation gesture
  map.touchZoomRotate.disableRotation();

  // Add controls to the map
  map.addControl(new NavigationControl({ showCompass: false }));
  map.addControl(new ScaleControl({ unit: 'imperial' }), 'bottom-right');

  // we wait for it to fully load so we can add sources and layers
  await map.once('load');

  // add our data source
  map.addSource(SOURCE, {
    type: 'vector',
    url: TILESET,
    promoteId: 'City',
  });

  // Add a layer showing polygons' lines
  map.addLayer({
    'id': 'line-layer',
    'type': 'line',
    'source': SOURCE,
    'source-layer': SOURCE_LAYER,
    'paint': {
      'line-width': 2,
      'line-color': '#333333',
      'line-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        1,
        0,
      ],
    },
  });

  // Add a layer to make polygons hover-able

  map.addLayer({
    'id': 'hover-layer',
    'type': 'fill',
    'source': SOURCE,
    'source-layer': SOURCE_LAYER,
    'paint': {
      'fill-opacity': 0,
    },
  });

  let activeId;

  function setActiveId(id, params, lngLat) {
    trendLookup(params).then(function (result) {
      // console.log('result', result);
      t = result;
      // if parameters and lon/lat exists, add a tooltip
      if (params && lngLat) {
        popup.setLngLat(lngLat);
        // console.log('params', params);
        // console.log('t', t);
        popup.setHTML(renderTooltip(params, t)).addTo(map);
      }
    });

    if (activeId) {
      map.setFeatureState(
        { source: SOURCE, sourceLayer: SOURCE_LAYER, id: activeId },
        { hover: false }
      );
    }

    map.setFeatureState(
      { source: SOURCE, sourceLayer: SOURCE_LAYER, id },
      { hover: true }
    );
    activeId = id;
    map.getCanvas().style.cursor = 'default';
  }

  function unsetActiveId() {
    if (activeId) {
      map.setFeatureState(
        { source: SOURCE, sourceLayer: SOURCE_LAYER, id: activeId },
        { hover: false }
      );

      activeId = undefined;
      map.getCanvas().style.cursor = '';
      popup.remove();
    }
  }

  map.on('mousemove', 'hover-layer', (e) => {
    const features = e.features;

    if (features.length > 0) {
      const feature = features[0];

      const featureId = feature.id;
      const props = feature.properties;

      setActiveId(featureId, props, e.lngLat);
    }
  });

  map.on('mouseleave', 'hover-layer', unsetActiveId);

  //Adding geocoder

  // document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
  findSvelteComponentContainer('#geocoder').appendChild(geocoder.onAdd(map));

  geocoder.on('result', function (e) {
    map.on('moveend', function () {
      var point = map.project(e.result.center);
      var feature = map.queryRenderedFeatures(point, {
        layers: ['hover-layer'],
      })[0];

      if (feature) {
        const featureId = feature.id;
        const props = feature.properties;

        setActiveId(featureId, props, e.result.center);
        popup.setLngLat(e.result.center);
        popup.setHTML(renderTooltip(props)).addTo(map);
      }
    });
  });
}
